<template>
  <div class="container" style="width: 1900px; page-break-after:always;">
    <!-- 打印按钮 -->
    <div class="print">
      <el-button v-loading="loading" type="primary" @click="downloadPDF">下载</el-button>
    </div>
    <div>
      <iframe id="iframe"
              refs="iframe"
              :src="iframeSrc"
              :style="{width: '1900px', height: autoHeight}"
              allowfullscreen="true" scrolling="no" frameborder="0" />
    </div>
  </div>
</template>

<script>
import { createPdf, getFileOssUrl } from '../../../api/util'
import { getCountPdf } from '../../../api/report'
import {downloadFile} from "../../../utils/download";

export default {
  name: 'ReportPdfPreview',
  data() {
    return {
      loading: false,
      iframeSrc: '',
      timer: null,
      autoHeight: '1200px'
    }
  },
  mounted() {
  },
  created() {
    const report_id = this.$route.query.report_id
    if (this.$route.query.is_new) {
      this.iframeSrc = 'https://erp-pre.zhian-design.com/pdf/new_report?report_id=' + report_id
      // this.iframeSrc = 'http://www.zhian-api.com/pdf/report?report_id=' + report_id
    } else {
      this.iframeSrc = 'https://erp-pre.zhian-design.com/pdf/report?report_id=' + report_id
    }
    // this.iframeSrc = 'http://www.zhian-api.com/pdf/report?report_id=' + report_id
    getCountPdf({ report_id: this.$route.query.report_id, get_page: 1 }).then((res) => {
      if (res.data.data) {
        this.autoHeight = 1180 * res.data.data + 'px'
      }
    })
  },
  methods: {
    downloadPDF() {
      if (this.loading) {
        this.$message.error('正在下载中，请耐心等待')
        return false
      }
      this.$message.success('提交下载成功，请耐心等待')
      this.loading = true
      localStorage.removeItem('download_pdf')
      createPdf({ 'pdf_type': 'worker_report', pdf_info: { report_id: this.$route.query.report_id }}).then((res) => {
        this.timer = setInterval(async () => {
          await getFileOssUrl({download_token: res.data.data}).then((ossResult) => {
            if (ossResult.data.data) {
              downloadFile(ossResult.data.data.replace('http:', 'https:'), this.$route.query.report_title + '.pdf')
              //window.open(ossResult.data.data, '_blank')
              this.loading = false
              clearInterval(this.timer)
            }
          })
          if (!this.loading) {
            return false
          }
          const pdfContent = localStorage.getItem('download_pdf')
          console.log('download_pdf.........', pdfContent)
          if (pdfContent) {
            const content = JSON.parse(pdfContent)
            if (content && content.oss_pdf_url && content.info && content.info.pdf_type === 'worker_report') {
              localStorage.removeItem('download_pdf')
              window.open(content.oss_pdf_url, '_blank')
              this.loading = false
              clearInterval(this.timer)
            }
          }
        }, 1000)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container{
  font-family: 'Calibri';
  margin: 0 auto;
  width: 1700px;
  .print{
    position: fixed;
    height: 56px;
    width: 100%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    z-index: 100;
  }
}
.pdf-items {
  width: 1700px; overflow: hidden; margin-top: 2px; page-break-after:always;
}
</style>
<style>
.page{
  box-sizing: border-box;
  border: 1px solid #666;
  margin-bottom: 8px;
}
#total-page {
  width: 1700px;
  margin: 0 auto;
  overflow: hidden;
}
.hidePage .page{
  border: none !important;
  margin-bottom: 0 !important;
}
.hidePage .splice::after,.hidePage .splice::before{
  display: none !important;
}
@media print {
  @page{
    size:auto;
    margin: 0mm;
  }
  .splice::after,.splice::before{
    display: none !important;
  }
  .page{
    border: none !important;
    margin-bottom: 0 !important;
  }
  .container{
    -webkit-print-color-adjust:exact;
    border: none !important;
  }
  .print{
    display: none !important;
  }
  .page-print-hide{
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/report-pdf-preview.vue